export default __webpack_public_path__ + "static/media/img3.3147d1f3.jpg";